import { useParams } from "@tanstack/react-router";
import { Suspense } from "react";
import {
	Tabs,
	TabsIndicator,
	TabsList,
	TabsPanel,
	TabsTab,
} from "@/components/Tabs";
import { PartnerAnalytics } from "./components/PartnerAnalytics";
import { PartnerAnalyticsSkeleton } from "./components/PartnerAnalyticsSkeleton";
import { PartnerAttributions } from "./components/PartnerAttributions";
import { PartnerAttributionsSkeleton } from "./components/PartnerAttributionsSkeleton";

export function PartnerDetailPage() {
	const { partnerId } = useParams({
		from: "/_app/partners/$partnerId/",
	});

	return (
		<div className="mt-6">
			<Tabs defaultValue="analytics">
				<TabsList>
					<TabsIndicator />
					<TabsTab value="analytics">Analytics</TabsTab>
					<TabsTab value="attributions">Attributed Subscribers</TabsTab>
				</TabsList>

				<TabsPanel value="analytics">
					<Suspense fallback={<PartnerAnalyticsSkeleton />}>
						<PartnerAnalytics partnerId={partnerId} />
					</Suspense>
				</TabsPanel>

				<TabsPanel value="attributions">
					<Suspense fallback={<PartnerAttributionsSkeleton />}>
						<PartnerAttributions partnerId={partnerId} />
					</Suspense>
				</TabsPanel>
			</Tabs>
		</div>
	);
}
